import React from "react";
import { TabsContent } from "../ui/tabs";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Globe, RefreshCw } from "lucide-react";

export default function MonetizeTab({
  dm, adsEnabled, setAdsEnabled,
  adsPublisherId, setAdsPublisherId,
  adsSlotId, setAdsSlotId,
  savingAds, saveAdsenseConfig,
}) {
  return (
    <TabsContent value="monetize">
      <div className="max-w-2xl">
        <div className="mb-6">
          <h2 className={`editorial-heading text-2xl font-medium ${dm ? "text-slate-100" : "text-[#191c1d]"}`}>Google AdSense</h2>
          <p className={`category-tag mt-1 ${dm ? "text-slate-500" : "text-[#6b7a7d]"}`}>When enabled, native ad cards appear every 5–6 articles in a non-intrusive way. Ads render on both the public landing and the authenticated feed.</p>
        </div>

        <div className={`rounded-2xl p-6 mb-5 ${dm ? "bg-[#1a2122]" : "bg-white"}`} style={{ boxShadow: "0 0 0 1px rgba(186,201,204,0.1), 0 4px 24px rgba(25,28,29,0.04)" }}>
          <div className={`flex items-center justify-between py-4 border-b ${dm ? "border-white/5" : "border-black/5"}`}>
            <div>
              <p className={`text-sm font-semibold ${dm ? "text-slate-200" : "text-[#191c1d]"}`}>Enable AdSense</p>
              <p className={`category-tag mt-0.5 ${dm ? "text-slate-500" : "text-[#6b7a7d]"}`}>Activate ad slots in the article feed</p>
            </div>
            <Switch checked={adsEnabled} onCheckedChange={setAdsEnabled} className="data-[state=checked]:bg-[#006874]" data-testid="adsense-toggle" />
          </div>

          <div className="py-4 space-y-4">
            <div>
              <Label className={`category-tag mb-1.5 block ${dm ? "text-slate-400" : "text-[#6b7a7d]"}`}>Publisher ID</Label>
              <Input value={adsPublisherId} onChange={e => setAdsPublisherId(e.target.value)}
                placeholder="ca-pub-0000000000000000"
                className={`border-0 font-mono text-sm ${dm ? "bg-[#252e2f] text-slate-200 placeholder:text-slate-600" : "bg-[#f3f4f5]"}`}
                data-testid="adsense-publisher-id" />
              <p className={`category-tag mt-1.5 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>Found in Google AdSense → Account → Account information → Publisher ID</p>
            </div>
            <div>
              <Label className={`category-tag mb-1.5 block ${dm ? "text-slate-400" : "text-[#6b7a7d]"}`}>Ad Slot ID</Label>
              <Input value={adsSlotId} onChange={e => setAdsSlotId(e.target.value)}
                placeholder="1234567890"
                className={`border-0 font-mono text-sm ${dm ? "bg-[#252e2f] text-slate-200 placeholder:text-slate-600" : "bg-[#f3f4f5]"}`}
                data-testid="adsense-slot-id" />
              <p className={`category-tag mt-1.5 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>Found in AdSense → Ads → By ad unit → Display ads → Ad unit code (data-ad-slot value)</p>
            </div>
          </div>

          <button onClick={saveAdsenseConfig} disabled={savingAds} data-testid="save-adsense-btn"
            className={`w-full py-3 rounded-full category-tag transition-all disabled:opacity-50 flex items-center justify-center gap-2 ${dm ? "bg-cyan-400 text-[#001f24] hover:bg-cyan-300" : "bg-[#006874] text-white hover:bg-[#004f58]"}`}>
            {savingAds ? <><RefreshCw className="w-3.5 h-3.5 animate-spin" />Saving…</> : <><Globe className="w-3.5 h-3.5" />Save AdSense Config</>}
          </button>
        </div>

        <div className={`rounded-2xl p-6 ${dm ? "bg-[#1a2122]" : "bg-white"}`} style={{ boxShadow: "0 0 0 1px rgba(186,201,204,0.1), 0 4px 24px rgba(25,28,29,0.04)" }}>
          <p className={`category-tag mb-4 ${dm ? "text-slate-500" : "text-[#6b7a7d]"}`}>AD SLOT PREVIEW</p>
          <div className={`rounded-xl border-2 border-dashed flex flex-col items-center justify-center p-10 ${dm ? "border-white/8" : "border-black/8"}`} style={{ minHeight: 150 }}>
            <Globe className={`w-5 h-5 mb-2 opacity-20 ${dm ? "text-slate-400" : "text-[#6b7a7d]"}`} />
            <p className={`category-tag opacity-40 ${dm ? "text-slate-500" : "text-[#bac9cc]"}`}>
              {adsEnabled && adsPublisherId ? `AdSense · ${adsPublisherId}` : adsEnabled ? "Enter Publisher ID to activate ads" : "Ads disabled"}
            </p>
          </div>
          <p className={`category-tag mt-3 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>Ads appear every 5–6 articles in a native card matching the feed layout. No intrusive banners.</p>
        </div>
      </div>
    </TabsContent>
  );
}
